import React from "react";
import { Row, Col, Button, Table } from "react-bootstrap";
import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';
import Card from "../../../components/Card";
import logo from "../../../assets/images/coyote-logo.jpg";
import "../../../assets/custom/css/quote.css";

const Quote = () => {
  const handleDownload = () => {
    const element = document.getElementById("invoice");

    if (!element) {
      console.error("Element not found!");
      return;
    }

    const opt = {
      margin: 0.7,
      filename: "invoice.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "cm", format: "letter", orientation: "portrait" },
    };

    html2pdf()
      .from(element)
      .set(opt)
      .toContainer()
      .toCanvas()
      .toPdf()
      .save()
      .then(() => {
        console.log("Invoice generated and downloaded");
      })
      .catch((error) => {
        console.error("Error generating Invoice:", error);
      });
  };

  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">Quote</h4>
                </div>
                <Button
                  type="submit"
                  variant="btn btn-primary"
                  className="ms-2"
                  onClick={handleDownload}
                >
                  Download Invoice
                </Button>
              </Card.Header>
              <Card.Body className="p-4">
                <div className="p-4">
                  <div className="quote-page m-0 p-0 bg-white" id="invoice">
                    <div className="container-quote bg-white">
                      <div className="coyote-header coyote-header d-flex justify-content-between align-content-end align-items-end">
                        <div className="coyote-logo">
                          <img
                            className="coyote-logo-image h-auto w-25"
                            src={logo}
                            alt="coyote-logo"
                          />
                        </div>
                        <div className="coyote-text">
                          <h1 className="m-0 text-center">QUOTE</h1>
                        </div>
                      </div>
                      <div className="company-info">
                        <p
                          className="details-label details-label-heading font-weight-bold"
                          style={{ fontWeight: "bold" }}
                        >
                          Coyote Cabling
                        </p>
                        <p>742 W Palms Drive</p>
                        <p>LAS CRUCES, NM, 88007</p>
                        <p>
                          Email:
                          <a
                            className="text-decoration-none"
                            href="mailto:admin@coyotecabling.com"
                          >
                            admin@coyotecabling.com
                          </a>
                        </p>
                      </div>
                      <div className="invoice-details d-flex justify-content-between align-content-end w-100">
                        <div className="customer-info">
                          <p className="details-label-customer fw-bolder text-black">
                            Customer Details:
                          </p>
                          <hr className="hr-left m-0" />
                          <span className="d-flex">
                            <p className="details-label width-20">Customer:</p>
                            <p>John Doe</p>
                          </span>
                          <span className="d-flex">
                            <p className="details-label width-20">Contact:</p>
                            <p>(555) 123-4567</p>
                          </span>
                          <span className="d-flex">
                            <p className="details-label width-20">Email:</p>
                            <p>
                              <a
                                className="text-decoration-none"
                                href="mailto:johndoe@example.com"
                              >
                                johndoe@example.com
                              </a>
                            </p>
                          </span>
                          <span className="d-flex">
                            <p className="details-label width-20">Address:</p>
                            <p>123 Main St, Las Cruces, NM</p>
                          </span>
                        </div>
                        <div className="customer-info-quote">
                          <p className="details-label-customer fw-bolder text-black">
                            Quote Details:
                          </p>
                          <hr className="hr-right w-100 m-0" />
                          <span className="d-flex">
                            <p className="details-label width-30">Quote # : </p>
                            <p>QN-000046</p>
                          </span>
                          <span className="d-flex">
                            <p className="details-label width-30">Date : </p>
                            <p>September 28, 2024</p>
                          </span>
                          <span className="d-flex">
                            <p className="details-label width-30">
                              <b>Description:</b>
                            </p>
                            <p>Quote for cabling installation.</p>
                          </span>
                        </div>
                      </div>
                      <Table
                        id="quote-list-table datatable table-striped"
                        className="w-100 mt-0 quote-table"
                        role="grid"
                        style={{ tableLayout: "fixed" }}
                        data-toggle="data-table"
                      >
                        <thead>
                          <tr
                            className="text-white font-weight-bold text-center align-middle"
                            style={{ fontWeight: "bold" }}
                          >
                            <th
                              scope="col"
                              className="text-break"
                              style={{
                                width: "10%",

                                whiteSpace: "normal",
                              }}
                            >
                              QTY
                            </th>
                            <th
                              scope="col"
                              className="text-break"
                              style={{
                                width: "15%",

                                whiteSpace: "normal",
                              }}
                            >
                              MANUFACTURER
                            </th>
                            <th
                              scope="col"
                              className="text-break"
                              style={{
                                width: "12%",

                                whiteSpace: "normal",
                              }}
                            >
                              PART NO.
                            </th>
                            <th
                              scope="col"
                              className="text-break"
                              style={{
                                width: "25%",

                                whiteSpace: "normal",
                              }}
                            >
                              DESCRIPTION
                            </th>
                            <th
                              scope="col"
                              className="text-break"
                              style={{
                                width: "10%",

                                whiteSpace: "normal",
                              }}
                            >
                              MSRP/COST
                            </th>
                            <th
                              scope="col"
                              className="text-break"
                              style={{
                                width: "9%",

                                whiteSpace: "normal",
                              }}
                            >
                              DISCOUNT
                            </th>
                            <th
                              scope="col"
                              className="text-break"
                              style={{
                                width: "9%",

                                whiteSpace: "normal",
                              }}
                            >
                              PRICE
                            </th>
                            <th
                              scope="col"
                              className="text-break"
                              style={{
                                width: "10%",

                                whiteSpace: "normal",
                              }}
                            >
                              TOTAL
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="align-middle">
                            <td
                              className="text-center text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              10
                            </td>
                            <td
                              className="text-left text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              Panduit
                            </td>
                            <td
                              className="text-left text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              CJ688TGBL
                            </td>
                            <td
                              className="text-left text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              UNIV BLACK MINI-COM TX6 PLUS CAT6 MO
                            </td>
                            <td
                              className="text-break"
                              style={{
                                position: "relative",

                                whiteSpace: "normal",
                                padding: "6px",
                              }}
                            >
                              <em
                                style={{
                                  position: "absolute",
                                  left: "0",
                                  paddingLeft: "6px",
                                }}
                              >
                                $
                              </em>
                              <span style={{ float: "right" }}>18.00</span>
                            </td>
                            <td className="text-center">29%</td>
                            <td
                              className="text-end text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              $12.78
                            </td>
                            <td
                              className="text-end text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              $127.80
                            </td>
                          </tr>
                          <tr className="align-middle">
                            <td
                              className="text-center text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              5000
                            </td>
                            <td
                              className="text-left text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              General Cable
                            </td>
                            <td
                              className="text-left text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              Cat6 CMP
                            </td>
                            <td
                              className="text-left text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              C6 GS6 BL CMP 1M&apos; SPC
                            </td>
                            <td
                              className="text-break"
                              style={{
                                position: "relative",

                                whiteSpace: "normal",
                                padding: "6px",
                              }}
                            >
                              <em
                                style={{
                                  position: "absolute",
                                  left: "0",
                                  paddingLeft: "6px",
                                }}
                              >
                                $
                              </em>
                              <span style={{ float: "right" }}>0.55</span>
                            </td>
                            <td className="text-center">29%</td>
                            <td
                              className="text-end text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              $0.39
                            </td>
                            <td
                              className="text-end text-break"
                              style={{
                                whiteSpace: "normal",
                              }}
                            >
                              $1,952.50
                            </td>
                          </tr>
                        </tbody>
                      </Table>

                      <div className="total-row d-flex w-100 align-content-end align-items-end text-black">
                        <div className="thank-you w-50">
                          <p>
                            Thanks for the opportunity to perform this work.
                          </p>
                        </div>

                        <div className="total text-end w-50">
                          <div className="total-cal-row d-flex justify-content-between align-items-center">
                            <p className="d-flex align-items-end">
                              Total Materials:
                            </p>
                            <p className="border-top-quote d-flex align-items-center justify-content-between">
                              {" "}
                              <em>$</em>2,080.30
                            </p>
                          </div>
                          <div className="total-cal-row d-flex justify-content-between align-items-center">
                            <p className="d-flex align-items-end">
                              Material Sales Tax:
                            </p>
                            <p className="d-flex align-items-center justify-content-between">
                              {" "}
                              <em>$</em>-
                            </p>
                          </div>
                          <div className="total-cal-row d-flex justify-content-between align-items-center">
                            <p className="d-flex align-items-end">
                              Labor Hours @ $74.88 | 56.7:
                            </p>
                            <p className="d-flex align-items-center justify-content-between">
                              <em>$</em>4,245.70
                            </p>
                          </div>
                          <div className="total-cal-row d-flex justify-content-between align-items-center">
                            <p className="d-flex align-items-end">
                              Total Labor:
                            </p>
                            <p className="d-flex align-items-center justify-content-between">
                              <em>$</em>4,245.70
                            </p>
                          </div>
                          <div className="total-cal-row d-flex justify-content-between align-items-center">
                            <p className="d-flex align-items-end">
                              Labor Sales Tax:
                            </p>
                            <p className="d-flex align-items-center justify-content-between">
                              <em>$</em>-
                            </p>
                          </div>

                          <div
                            className="total-cal-row d-flex justify-content-between align-items-center"
                            style={{ marginTop: "0.5rem" }}
                          >
                            <p className="d-flex align-items-end">Bond:</p>
                            <p className="border-top-quote d-flex align-items-center justify-content-between">
                              {" "}
                              <em>$</em>126.52
                            </p>
                          </div>
                          <div className="total-cal-row d-flex justify-content-between align-items-center grand-total fw-bold font-weight-bolder border-bottom-0">
                            <p className="mt-0 mb-0 d-flex align-items-end">
                              Grand Total:
                            </p>
                            <p
                              className="d-flex align-items-center justify-content-between mt-0 mb-0"
                              style={{
                                borderBottom: "0px",
                              }}
                            >
                              {" "}
                              <em>$</em>6,452.52
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="footer text-center text-black">
                      <p>1</p>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Quote;
